export default __webpack_public_path__ + "static/media/fantom.d424ca5f.svg";